export default __webpack_public_path__ + "media/images/transverse_32-ad8545dd1d85c5b22b9cb8c8f1e13483.png";